import { Inputfiledsbase } from './models/inputfiledsbase';

export class CheckboxQuestion extends Inputfiledsbase<string> {
  override controlType = 'checkbox';
}